export const high_numberOfStrands = 6;
export const high_strands = [
  'GGCAACUUUGAUCCCUCGGUUUAGCGCCGGCCUUUUCUCCCACACUUUCACG',
  'GGGAAAUUUCGUGGUAGGUUUUGUUGCCCGUGUUUCUACGAUUACUUUGGUC',
  'GGACAUUUUCGAGACAGCAUUUUUUCCCGACCUUUGCGGAUUGUAUUUUAGG',
  'GGCGCUUUUGACCUUCUGCUUUAUGUCCCCUAUUUCUUAAUGACUUUUGGCC',
  'GGGAGAUUUAGUCAUUAAGUUUUACAAUCCGCUUUGUAAUCGUAGUUUGUGU',
  'GGGAUCUUUACCUACCACGUUUUGCUGUCUCGUUUGCAGAAGGUCUUUCCGA'
];